// Lib
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Components
import Form from './index';
import FooterButtons from '../../Modal/FooterButtons';

// Hooks
import useAddressForm from '../../../pages/AddressBook/hooks/useAddressForm';
import ErrorMessage from '../../Error/ErrorMessage';

// Actions
import { ClearApiError } from '../../../actions/apiError';

// Styles
import { useStyles } from './AddressFormStyles';

const AddressForm = ({ address = {}, editMode = false }) => {
  const dispatch = useDispatch();
  const {
    onClose,
    onSubmit,
    onChangeSelect,
    onChangeInput,
    states,
    countries,
    isLoading,
    apiErrors,
    uspsError,
    apiError,
  } = useAddressForm(editMode, address.id);

  const [visible, setVisible] = useState(true);
  const hideElement = useCallback(() => setVisible(false), []);
  const showElement = useCallback(() => setVisible(true), []);

  const { classes } = useStyles();

  useEffect(() => {
    return () => {
      dispatch(ClearApiError());
    };
  }, [dispatch]);

  return (
    <Form
      onChangeSelect={onChangeSelect}
      onChangeInput={onChangeInput}
      states={states}
      countries={countries}
      apiErrors={apiErrors}
      uspsError={uspsError}
      onSubmit={onSubmit}
      address={address}
      hideElement={hideElement}
      showElement={showElement}>
      {apiError && <ErrorMessage message={apiError} />}
      {visible && (
        <FooterButtons
          className={classes.buttons}
          isLoading={isLoading}
          onReject={onClose}
          rejectTitle="Cancel"
          acceptTitle="Save"
          acceptBtnType="submit"
        />
      )}
    </Form>
  );
};

export default AddressForm;
